<template>
  <div>
    <v-list-tile v-if="loading">
      <v-progress-circular indeterminate class="primary--text"></v-progress-circular>
    </v-list-tile>
    <v-list-tile v-else avatar @click="openDialogUpdate()">
      <v-list-tile-avatar>
        <v-icon class="primary white--text">short_text</v-icon>
      </v-list-tile-avatar>
      <v-list-tile-content>
        <v-list-tile-title>{{ entity.code }} <!-- <span v-for="fa in entity.ex" :key="fa"> / {{ fa }} </span>--></v-list-tile-title>
        <v-list-tile-sub-title><span v-for="fa in entity.ex" :key="fa"> {{ fa }} ; </span></v-list-tile-sub-title>
      </v-list-tile-content>
      <v-list-tile-action>
        <v-menu bottom left>
          <v-btn icon="icon" slot="activator" @mouseover.native="overMenu = true" @mouseleave.native="overMenu = false">
            <v-icon>more_vert</v-icon>
          </v-btn>
          <v-list dense>
            <v-list-tile @click="openDialogUpdate()">
              <v-list-tile-action>
                <v-icon>edit</v-icon>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title>{{ $t('edit') | cap }} {{ $tc('Entity', 1) }}</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile @click="openDialogDeleteEntity(entity.code, entity.botWorkspace)">
              <v-list-tile-action>
                <v-icon>delete</v-icon>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title>{{ $t('delete') | cap }} {{ $tc('Entity', 1) }}</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-list>
        </v-menu>
      </v-list-tile-action>
    </v-list-tile>

    <v-dialog v-model="showDialogUpdate" max-width="490">
      <v-card>
        <v-card-title class="primary white--text">{{ $t('edit') | cap }} {{ $tc('Entity', 1) }} : {{entity.code}}</v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-text-field
            required
            :label="$t('entityCode')" 
            v-model="entityDialog.code"
            counter 
            max="32" >
          </v-text-field>
		  
          <v-card-text >
             <v-fab-transition slot="activator">
             </v-fab-transition>
             <v-data-table
               :items="samples"
               hide-actions
             >
               <template slot="items" slot-scope="props">
                 <td>
                   <v-edit-dialog
                     :cancel-text="$t('cancel')"
                     :save-text="$t('submit')"
                     :return-value.sync="samples"
                     large
                     lazy
                   >
                     <div><code>{{ props.item.content }}</code></div>
                     <div slot="input" class="mt-3 title">{{ $t('editContent') }}</div>
                     <v-text-field
                       slot="input"
                       label="Modification"
                       v-model="props.item.content"
                       single-line
                       counter
                       autofocus
                     ></v-text-field>
                   </v-edit-dialog>
                 </td>
                 <td class="text-xs-right">
                   <v-btn icon flat @click.stop="openDialogDeleteSample(props.item)">
                     <v-icon>delete</v-icon>
                   </v-btn>
                 </td>
               </template>
             </v-data-table>
          </v-card-text>
          <v-btn
            class="secondary"
            dark
            bottom
            left
            @click.stop="addExample()"
          >
            <v-icon>add</v-icon>
          </v-btn>
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn flat @click="showDialogUpdate = false">{{ $t('cancel') }}</v-btn>
          <v-btn color="primary" :disabled="wzErrors.any()" @click="submitDialogUpdate">{{ $t('submitWatson') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showDialogDeleteSample" max-width="490">
      <v-card>
        <v-card-title class="primary white--text">{{ $t('delete') | cap }} {{ $tc('entityExample', 1) }}</v-card-title>
        <v-card-text>
          {{ $t('delete') | cap }} {{ $tc('entityExample', 1) }} "{{ sampleToDelete.content }}"?
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn flat @click.native="showDialogDeleteSample = false">{{ $t('cancel') }}</v-btn>
          <v-btn color="primary" @click.native="submitDialogDelete">{{ $t('delete') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showDialogDeleteEntity" max-width="490">
      <v-card>
        <v-card-title class="primary white--text">{{ $t('delete') | cap }} {{ $tc('Entity', 1) }}</v-card-title>
        <v-card-text>
          {{ $t('delete') | cap }} "{{ entityToDelete }}"?
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn flat @click.native="showDialogDeleteEntity = false">{{ $t('cancel') }}</v-btn>
          <v-btn color="primary" @click.native="submitDialogDeleteEntity">{{ $t('deleteWatson') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showDialogCreate" max-width="290">
      <v-card>
        <v-card-title class="primary white--text">{{ $t('addSample') }}</v-card-title>
          <form>
            <v-text-field
              autofocus
              v-model="sampleToCreate"
              :label="$t('entityExample')" 
              @keyup.native.enter="submitDialogCreate()"
            ></v-text-field>
          </form>
          <v-card-actions>
            <v-spacer/>
            <v-btn flat @click.native="showDialogCreate = false">{{ $t('cancel') }}</v-btn>
            <v-btn color="primary" @click.native="submitDialogCreate">{{ $t('add') }}</v-btn>
          </v-card-actions>
        </v-card-title>
      </v-card>
    </v-dialog>

  </div>
</template>

<script>
import _ from 'lodash'

export default {

  props: {
    entity: {
      type: Object,
      required: true
    }
  },

  data () {
    return {
      /**
       * affiche/cache la fenetre de dialog de modification
       * @type {Boolean}
       */
      showDialogUpdate: false,
      /**
       * affiche/cache la fenetre de dialog de suppression
       * @type {Boolean}
       */
      showDialogDeleteSample: false,
      showDialogDeleteEntity: false,
      showDialogCreate: false,
      /**
       * phrase qui sera utilisée dans la fenêtre de dialogue de modification
       * @type {Object}
       */
      entityDialog: {},
      loading: false,
      overMenu: false,
      samples: [],
      sampleToDelete: {},
      entityToDelete: '',
      sampleToCreate: '',
      sampleOriginalName: '',
      botWorkspace: ''
    }
  },

  methods: {
    openDialogUpdate () {
      this.samples = []
      if (!this.overMenu) {
        this.entityDialog = _.clone(this.entity)
        this.sampleOriginalName = this.entityDialog.code
        this.botWorkspace = this.entityDialog.botWorkspace
        this.showDialogUpdate = true
        for (var n in this.entityDialog.ex) {
          this.samples.push({ content: this.entityDialog.ex[n], index: n })
        }
      }
    },
    openDialogDeleteSample (code) {
      this.showDialogCreateSample = false
      this.showDialogDeleteSample = true
      this.showDialogDeleteEntity = false
      this.sampleToDelete = code
    },
    openDialogDeleteEntity (code, botWorkspace) {
      this.showDialogCreateSample = false
      this.showDialogDeleteSample = false
      this.showDialogDeleteEntity = true
      this.entityToDelete = code
      this.botWorkspace = botWorkspace
    },
    submitDialogUpdate () {
      this.showDialogUpdate = false

      let dataToPost = new window.FormData()
      dataToPost.append('code', this.entityDialog.code)
      dataToPost.append('origin', this.sampleOriginalName)
      dataToPost.append('samples', JSON.stringify(this.samples))
      dataToPost.append('botWorkspace', this.botWorkspace)
      this.loading = true

      this.axios.post('https://public.targetfirst.com/public/ibm/edit_entity.php', dataToPost, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}})
      /* this.axios.post('put/entity.php', dataToPost, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}}) */
      .then(response => {
        // Notification
        this.$store.dispatch('_Notifier/NEW_NOTIF', { message: this.$t('modifSuccess'), context: 'success' })
        this.$store.commit('_User/RELOAD_WATSON', {
          editWatson: Math.random()
        })
      })
      .catch(_ => {
        this.$store.dispatch('_Notifier/NEW_NOTIF', { message: this.$t('modifFailure'), context: 'error' })
      })
      .then(_ => {
        this.loading = false
      })
    },

    submitDialogDelete () {
      this.showDialogDeleteSample = false
      if (this.sampleToDelete !== '') {
        this.samples.splice(this.sampleToDelete.index, 1)
        this.sampleToDelete = {}
      }
    },
    submitDialogDeleteEntity () {
      this.showDialogDeleteEntity = false
      if (this.entityToDelete !== '') {
        let dataToPost = new window.FormData()
        dataToPost.append('code', this.entityToDelete)
        dataToPost.append('botWorkspace', this.botWorkspace)

        this.loading = true

        this.axios.post('https://public.targetfirst.com/public/ibm/delete_entity.php', dataToPost, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}})
        /* this.axios.post('put/entity.php', dataToPost, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}}) */
        .then(response => {
          // Notification
          this.$store.dispatch('_Notifier/NEW_NOTIF', { message: this.$t('modifSuccess'), context: 'success' })
          this.$store.commit('_User/RELOAD_WATSON', {
            editWatson: Math.random()
          })
        })
        .catch(_ => {
          this.$store.dispatch('_Notifier/NEW_NOTIF', { message: this.$t('modifFailure'), context: 'error' })
        })
        .then(_ => {
          this.loading = false
          // window.location.reload();
        })
        this.entityToDelete = ''
      }
    },
    submitDialogCreate () {
      this.showDialogCreate = false
      if (this.sampleToCreate !== '') {
        this.samples.push({content: this.sampleToCreate, index: this.samples.length})
        this.sampleToCreate = {}
      }
    },
    addExample () {
      this.showDialogDeleteSample = false
      this.showDialogDeleteEntity = false
      this.showDialogCreate = true
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/watcheezy/WzEntity.vue